<template>
  <fullscreen
    v-model="fullscreen"
    :class="{ white: fullscreen }"
    style="overflow: auto; height: 100%"
    class="d-flex flex-column"
  >
    <div class="pa-2">
      <div v-if="!fullscreen" class="mb-1">
        <span class="ml-1 font-weight-medium">สถานะ Device</span>
      </div>
      <v-card outlined class="px-2 py-1">
        <div class="d-flex justify-space-between align-center">
          <div>
            <v-btn icon @click="setFullscreen">
              <v-icon size="36" v-if="!fullscreen">mdi-fullscreen</v-icon>
              <v-icon size="36" v-else>mdi-fullscreen-exit</v-icon>
            </v-btn>
          </div>
          <div class="d-flex align-center">
            <div class="mb-1">
              <label class="caption ml-2">ค้นหา</label>
              <v-text-field
                v-model="search"
                placeholder="ค้นหา Device"
                prepend-inner-icon="mdi-magnify"
                flat
                outlined
                dense
                hide-details
                style="width: 200px; padding: 0 5px"
                clearable
                @click:clear="handleSearchClear"
              ></v-text-field>
            </div>
            <div>
              <label class="caption ml-1 d-block">ตัวกรอง: พื้นที่</label>
              <v-dialog
                v-model="dialogAreas"
                scrollable
                max-width="420px"
                persistent
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="text-capitalize"
                    height="40"
                    elevation="1"
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left>mdi-filter</v-icon>
                    เลือกดูเฉพาะพื้นที่
                    <v-avatar class="ml-2" color="primary" size="24">
                      <span class="white--text subtitle-2">
                        {{ selectedAreas === null ? 0 : selectedAreas.length }}
                      </span>
                    </v-avatar>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <v-checkbox
                      v-model="selectedAreasAll"
                      label="เลือกทั้งหมด"
                      :indeterminate="
                        selectedAreas.length > 0 &&
                        selectedAreas.length < filterAreas.length
                      "
                      hide-details
                      class="mt-0 mb-2"
                    ></v-checkbox>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text style="height: 300px">
                    <v-text-field
                      v-model="searchAreas"
                      outlined
                      dense
                      hide-details
                      prepend-inner-icon="mdi-magnify"
                      class="mt-4"
                    ></v-text-field>
                    <div>
                      <v-checkbox
                        v-model="selectedAreas"
                        v-for="item in filterAreas.sort((a, b) =>
                          a.area.localeCompare(b.area)
                        )"
                        :key="item.area"
                        :label="item.area === 'undefined' ? '-' : item.area"
                        :value="item.area"
                        hide-details
                      ></v-checkbox>
                    </div>
                    <div
                      v-if="filterAreas.length === 0"
                      class="text-center py-4"
                    >
                      {{ filterAreas.length === 0 ? 'ไม่พบข้อมูล' : '' }}
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialogAreas = false"
                    >
                      ตกลง
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </div>
        </div>
      </v-card>
      <v-card outlined class="mt-2 px-4 py-4">
        <div>
          <div class="d-flex align-center mb-2">
            <label class="ml-1" style="font-size: 14px">สถานะ Device</label>
            <div class="vertical-divider" />
            <v-checkbox
              v-model="displayDeviceName"
              class="ma-0 pa-0"
              hide-details
              dense
            >
              <template v-slot:label>
                <span style="font-size: 14px">แสดง Device Name</span>
              </template>
            </v-checkbox>
          </div>
          <div class="d-flex align-center">
            <v-checkbox
              v-model="connected"
              class="mt-0 d-inline-block mr-4"
              hide-details
              dense
              :readonly="!disconnected"
            >
              <template v-slot:label>
                <span style="font-size: 14px">Connected</span>
              </template>
            </v-checkbox>
            <v-checkbox
              v-model="disconnected"
              class="mt-0 d-inline-block"
              hide-details
              dense
              :readonly="!connected"
            >
              <template v-slot:label>
                <span style="font-size: 14px">Disconnected</span>
              </template>
            </v-checkbox>
            <div class="vertical-divider" />
            <v-checkbox
              v-model="locked"
              class="mt-0 d-inline-block mr-4"
              hide-details
              dense
            >
              <template v-slot:label>
                <span style="font-size: 14px">Locked</span>
              </template>
            </v-checkbox>
            <v-checkbox
              v-model="unlocked"
              class="mt-0 d-inline-block mr-4"
              hide-details
              dense
            >
              <template v-slot:label>
                <span style="font-size: 14px">Unlocked</span>
              </template>
            </v-checkbox>
            <v-checkbox
              v-model="door_alarm"
              class="mt-0 d-inline-block mr-4"
              hide-details
              dense
            >
              <template v-slot:label>
                <span style="font-size: 14px">Door Alarm</span>
              </template>
            </v-checkbox>
            <v-checkbox
              v-model="fire_alarm"
              class="mt-0 d-inline-block mr-4"
              hide-details
              dense
            >
              <template v-slot:label>
                <span style="font-size: 14px">Fire Alarm</span>
              </template>
            </v-checkbox>
            <v-checkbox
              v-model="unknown"
              class="mt-0 d-inline-block mr-4"
              hide-details
              dense
            >
              <template v-slot:label>
                <span style="font-size: 14px">Unknown</span>
              </template>
            </v-checkbox>
          </div>
        </div>
      </v-card>
    </div>
    <div class="px-2">
      <v-data-table
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        :loading="loading"
        loading-text="Loading... Please wait"
        :headers="headers"
        :items="hardwareStatus"
        :items-per-page="-1"
        class="elevation-1"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50, 100, -1],
          itemsPerPageText: 'Rows per page:',
        }"
        hide-default-footer
      >
        <template v-slot:item.area="{ item }">
          <span v-if="item.area === 'undefined'">-</span>
          <span v-else>{{ item.area }}</span>
        </template>
        <template v-slot:item.hardware_status="{ item }">
          <v-chip
            v-for="hardware in item.hardwares"
            :key="hardware.hardware_uuid"
            :color="hardware.is_connected ? 'green' : 'red'"
            class="mr-2 my-1"
            outlined
            text-color="#424242"
            small
          >
            <span
              style="font-size: 12px; color: #616161"
              class="d-flex align-center"
            >
              <span>{{ hardware.hardware_code }}</span>
              <span v-if="displayDeviceName"
                >-{{ hardware.title_th || 'ไม่มีชื่อ' }}</span
              >
              <span
                style="
                  margin: 0 6px;
                  width: 1px;
                  height: 13px;
                  background-color: #bdbdbd;
                  display: inline-block;
                "
              ></span>
              <span
                v-if="!hardware.is_connected"
                class="grey--text text--darken-4"
                >Unknown</span
              >
              <div v-else>
                <span
                  v-if="hardware.door_status_code === 'unlocked'"
                  class="red--text text--darken-4"
                  >Unlocked</span
                >
                <span
                  v-if="hardware.door_status_code === 'locked'"
                  class="green--text text--darken-4"
                  >Locked</span
                >
                <span
                  v-if="hardware.door_status_code === 'door_alarm'"
                  class="red--text text--darken-4 blink-text"
                  >Door Alarm</span
                >
                <span
                  v-if="hardware.door_status_code === 'fire_alarm'"
                  class="red--text text--darken-4 blink-text"
                  >Fire Alarm</span
                >
                <span
                  v-if="hardware.door_status_code === 'unknown'"
                  class="red--text text--darken-4 blink-text"
                  >Unknown</span
                >
                <span
                  v-if="!hardware.door_status_code"
                  class="grey--text text--darken-4"
                  >Unknown</span
                >
              </div>
            </span>
          </v-chip>
        </template>
      </v-data-table>
    </div>
  </fullscreen>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'

import { WEBSOCKET_CONFIG } from '@/constants/websocket'

export default {
  data() {
    return {
      displayDeviceName: false,
      connected: true,
      disconnected: true,
      locked: true,
      unlocked: true,
      door_alarm: true,
      fire_alarm: true,
      unknown: true,
      websocketReconnectCount: 0,
      searchAreas: '',
      selectedAreas: [],
      dialogAreas: false,
      websocket: null,
      fullscreen: false,
      sortBy: ['area'],
      sortDesc: [false],
      loading: false,
      search: '',
      headers: [
        {
          text: 'พื้นที่',
          align: 'start',
          value: 'area',
          width: 280,
        },
        { text: 'สถานะ Device', sortable: false, value: 'hardware_status' },
      ],
      areas: [],
    }
  },
  computed: {
    hardwares() {
      return this.$store.state.hardware.hardwares
    },
    selectedAreasAll: {
      set(val) {
        if (val) {
          // ✅ ใช้ filterAreas เพื่อให้รองรับ search
          this.selectedAreas = this.filterAreas.map((item) => item.area)
        } else {
          this.selectedAreas = []
        }
      },
      get() {
        return (
          this.selectedAreas.length === this.filterAreas.length &&
          this.filterAreas.length > 0
        )
      },
    },
    groupedByArea() {
      return _.chain(this.hardwares)
        .groupBy('area.title_th')
        .map((value, key) => ({ area: key, hardwares: value }))
        .value()
    },
    filteredByConnection() {
      return this.groupedByArea.map((item) => ({
        ...item,
        hardwares: item.hardwares.filter((hardware) =>
          hardware.is_connected ? this.connected : this.disconnected
        ),
      }))
    },
    filteredByDoorStatus() {
      return this.filteredByConnection.map((item) => ({
        ...item,
        hardwares: item.hardwares.filter((hardware) => {
          if (hardware.door_status_code === 'locked') return this.locked
          if (hardware.door_status_code === 'unlocked') return this.unlocked
          if (hardware.door_status_code === 'door_alarm') return this.door_alarm
          if (hardware.door_status_code === 'fire_alarm') return this.fire_alarm
          if (
            hardware.door_status_code === 'unknown' ||
            hardware.door_status_code === null
          )
            return this.unknown
          return true
        }),
      }))
    },
    filteredBySearch() {
      if (!this.search) return this.filteredByDoorStatus

      const searchLower = this.search.toLowerCase()

      return this.filteredByDoorStatus
        .map((item) => {
          const areaMatch =
            item.area && String(item.area).toLowerCase().includes(searchLower)

          const matchedHardwares = item.hardwares.filter((hardware) => {
            const code = hardware.hardware_code
              ? String(hardware.hardware_code).toLowerCase()
              : ''
            const title = hardware.title_th
              ? String(hardware.title_th).toLowerCase()
              : ''
            return code.includes(searchLower) || title.includes(searchLower)
          })

          return areaMatch
            ? { ...item }
            : { ...item, hardwares: matchedHardwares }
        })
        .filter(
          (item) =>
            (item.area &&
              String(item.area).toLowerCase().includes(searchLower)) ||
            item.hardwares.length > 0
        )
    },
    hardwareStatus() {
      return this.filteredBySearch
        .filter((item) => {
          if (this.selectedAreas.length === 0) return true
          return this.selectedAreas.includes(item.area)
        })
        .map((item) => ({
          ...item,
          hardwares: item.hardwares.sort((a, b) =>
            a.title_th.localeCompare(b.title_th)
          ),
        }))
    },
    filterAreas() {
      return this.areas.filter((item) => {
        return item.area.toLowerCase().includes(this.searchAreas.toLowerCase())
      })
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'สถานะ Device',
        disabled: true,
      },
    ])

    try {
      const { company_uuid } = this.$store.state.authentication.company

      this.$store.state.loading = true

      const payload = {
        params: {
          dpc: 'monitor-hardware-status-to-list-hardware',
          company_uuid,
        },
      }
      await this.fetchHardwares(payload)

      this.areas = this.hardwareStatus.map((item) => {
        return { area: item.area }
      })

      this.connectWebsocket()
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.$store.state.loading = false
    }
  },
  methods: {
    ...mapActions({
      fetchHardwares: 'hardware/fetchHardwares',
    }),
    handleSearchClear() {
      this.search = ''
    },
    filterHardwareStatus(value, search, item) {
      return (
        item.area.toLowerCase().includes(search.toLowerCase()) ||
        item.hardwares.some((hardware) =>
          hardware.hardware_code.toLowerCase().includes(search.toLowerCase())
        ) ||
        item.hardwares.some((hardware) =>
          hardware.title_th.toLowerCase().includes(search.toLowerCase())
        )
      )
    },
    connectWebsocket() {
      if (process.env.NODE_ENV === 'development') {
        console.log(
          '[WebSocket]',
          `call function connect websocket :: ${new Date()}`
        )
      }

      const { company_uuid } = this.$store.state.authentication.company

      if (this.websocket) {
        if (process.env.NODE_ENV === 'development') {
          console.log('[WebSocket]', `clear old websocket :: ${new Date()}`)
        }

        this.websocket.close()
      }

      if (process.env.NODE_ENV === 'development') {
        console.log(
          '[WebSocket]',
          `Starting Connection to WebSocket Server :: ${new Date()}`
        )
      }

      this.websocket = new WebSocket(
        process.env.VUE_APP_API_WEB_SOCKET_ENDPOINT
      )

      this.websocket.onopen = () => {
        if (process.env.NODE_ENV === 'development') {
          console.log(
            '[WebSocket]',
            `Successfully connected to the echo WebSocket Server :: ${new Date()}`
          )
        }

        // SEND MESSAGE TOPIC
        this.sendMessage({
          scope: `${process.env.VUE_APP_REALTIME_ENV_SCOPE}:${company_uuid}`,
          topic: 'hardware_status',
          // args: {
          //   area_uuid: [],
          //   is_connected: [],
          // },
        })
      }

      this.websocket.onmessage = (event) => {
        try {
          const data = JSON.parse(event?.data)
          const hardware = JSON.parse(data?.payload)

          const hardwares = this.$store.state.hardware.hardwares.map((item) => {
            if (item.hardware_uuid === hardware.hardware_uuid) {
              return {
                ...item,
                is_connected: hardware.is_connected,
                door_status_code: hardware.door_status_code,
              }
            } else {
              return item
            }
          })
          this.$store.commit('hardware/SET_HARDWARES', hardwares)
        } catch (error) {
          console.error('[WebSocket] Failed to parse message:', error)

          if (process.env.NODE_ENV === 'development') {
            console.log('[WebSocket] Raw data:', event.data)
          }
        }
      }

      this.websocket.onclose = (event) => {
        if (process.env.NODE_ENV === 'development') {
          console.log('[WebSocket]', `${event} :: ${new Date()}`)
        }

        if (event.wasClean) {
          if (process.env.NODE_ENV === 'development') {
            console.log(
              '[WebSocket]',
              `[close] Connection closed cleanly, code=${event.code} reason=${
                event.reason
              } :: ${new Date()}`
            )
          }
        } else {
          // e.g. server process killed or network down
          // event.code is usually 1006 in this case
          if (process.env.NODE_ENV === 'development') {
            console.log(
              '[WebSocket]',
              `${
                window?.navigator?.onLine ? 'online' : 'offline'
              } :: ${new Date()}`
            )
            console.log(
              '[WebSocket]',
              `[close] Connection died :: ${new Date()}`
            )
          }

          this.handleReconnectWebsocket()
        }
      }

      this.websocket.onerror = (error) => {
        console.error('[WebSocket Error]', error)

        // Show error to user
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          color: 'error',
          timeout: -1,
          message: 'เกิดข้อผิดพลาดในการเชื่อมต่อ WebSocket',
        })

        if (process.env.NODE_ENV === 'development') {
          console.log('[WebSocket]', `[error] ${error} :: ${new Date()}`)
        }
      }
    },
    handleReconnectWebsocket: _.debounce(function () {
      if (process.env.NODE_ENV === 'development') {
        console.log(
          '[WebSocket]',
          `call handle reconnect websocket :: ${new Date()}`
        )
      }

      this.websocketReconnectCount += 1

      if (
        this.websocketReconnectCount <= WEBSOCKET_CONFIG.RECONNECT_MAX_ATTEMPTS
      ) {
        if (process.env.NODE_ENV === 'development') {
          console.log(
            '[WebSocket]',
            `reconnect websocket : ${
              this.websocketReconnectCount
            } :: ${new Date()}`
          )
        }

        this.connectWebsocket()
      } else {
        if (process.env.NODE_ENV === 'development') {
          console.log('[WebSocket]', `refresh page :: ${new Date()}`)
        }

        // refresh page
        this.$router.go(0)
      }
    }, WEBSOCKET_CONFIG.RECONNECT_DELAY),
    sendMessage(message) {
      if (this.websocket) {
        this.websocket.send(JSON.stringify(message))
      }
    },
    setFullscreen() {
      this.fullscreen = !this.fullscreen
    },
  },
  beforeDestroy() {
    // Clear WebSocket
    if (this.websocket) {
      this.websocket.onopen = null
      this.websocket.onmessage = null
      this.websocket.onclose = null
      this.websocket.onerror = null
      this.websocket.close()
      this.websocket = null
    }

    // ✅ Cancel the actual debounced method
    if (this.handleReconnectWebsocket?.cancel) {
      this.handleReconnectWebsocket.cancel()
    }

    // Clear reconnect count
    this.websocketReconnectCount = 0
  },
}
</script>

<style scoped>
@keyframes blink {
  50% {
    opacity: 0;
  }
}

.blink-text {
  animation: blink 1s infinite;
}

.vertical-divider {
  width: 1px;
  background-color: #e0e0e0;
  height: 18px;
  margin: 0 8px;
}
</style>
